import { render, staticRenderFns } from "./red-packet-close.mpx?vue&type=template&id=36d7acae&scoped=true&isComponent&outputPath=components%2Fred-packet-closefccd8b2c%2Findex"
import script from "./red-packet-close.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fred-packet-closefccd8b2c%2Findex"
export * from "./red-packet-close.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fred-packet-closefccd8b2c%2Findex"
import style0 from "./red-packet-close.mpx?vue&type=style&index=0&id=36d7acae&prod&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22mfccd8b2c%22%7D&isComponent&outputPath=components%2Fred-packet-closefccd8b2c%2Findex"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d7acae",
  null
  
)

export default component.exports